import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useState, } from 'react';
import { cancelNewPasswordChallenge, completeNewPassword, getCurrentSession, parseHashTokens, signIn, signOut, } from './cognito';
const AuthContext = createContext(null);
export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [newPasswordEmail, setNewPasswordEmail] = useState(null);
    useEffect(() => {
        const fromHash = parseHashTokens();
        if (fromHash) {
            setUser(fromHash);
            setLoading(false);
            return;
        }
        getCurrentSession().then((sessionUser) => {
            setUser(sessionUser);
            setLoading(false);
        });
    }, []);
    const login = useCallback(async (email, password) => {
        const result = await signIn(email, password);
        if (result.status === 'newPasswordRequired') {
            setNewPasswordEmail(result.email);
            return 'newPasswordRequired';
        }
        setNewPasswordEmail(null);
        setUser(result.user);
        return 'authenticated';
    }, []);
    const finishNewPassword = useCallback(async (newPassword) => {
        const authUser = await completeNewPassword(newPassword);
        setNewPasswordEmail(null);
        setUser(authUser);
    }, []);
    const cancelNewPassword = useCallback(() => {
        cancelNewPasswordChallenge();
        setNewPasswordEmail(null);
    }, []);
    const logout = useCallback(() => {
        signOut();
        setNewPasswordEmail(null);
        setUser(null);
    }, []);
    return (_jsx(AuthContext.Provider, { value: {
            user,
            loading,
            newPasswordEmail,
            login,
            finishNewPassword,
            cancelNewPassword,
            logout,
        }, children: children }));
}
export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx)
        throw new Error('useAuth must be used within AuthProvider');
    return ctx;
}
